<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="chat__contact flex items-center px-2 pt-4 pb-2">
        <div class="contact__avatar mr-1">
            <vs-avatar class="border-2 border-solid"
                       :class="contact.people[0].person.is_online ? 'border-success' : 'border-danger'"
                       :src="contact.is_direct_chat ? contact.people[0].person.custom_json.avatarUrl : null"
                       size="42px"/>
        </div>
        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info flex flex-col truncate w-5/6">
                <h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">{{
                        contact.is_direct_chat ? contact.people[0].person.last_name + ' ' + contact.people[0].person.first_name : null
                    }}</h5>
                <span class="truncate text-xs">{{
                        (contact.last_message.text.length > 0 && contact.last_message.sender_username === userInfo.username) ? 'Bạn: ' : null
                    }} {{
                        (contact.last_message.text.length > 0) ? contact.last_message.text : (contact.last_message.text.length === 0 && contact.last_message.attachments.length > 0) ? 'File phương tiện' : null
                    }}</span>
            </div>

            <!--            <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">-->
            <!--                                <span class="whitespace-no-wrap">{{ lastMessaged | date }}</span>-->
            <!--                <vs-chip class="number" color="primary" v-if="unseenMsg">{{ unseenMsg }}</vs-chip>-->
            <!--            </div>-->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contact: {type: Object, required: true,},
        isActiveChatUser: {type: Boolean},
        lastMessaged: {type: String, default: "",},
        unseenMsg: {type: Number, default: 0,},
        userInfo: {type: Object}
    },
}
</script>

